module.exports = __webpack_public_path__ + "data/priveleges.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/privileges/priveleges.json
// module id = k0Kv
// module chunks = 1